import React, { useEffect, useState } from 'react';
import HeaderEntreprise from '../../header/headerEntreprise';
import './CandidaturesEntreprise.css';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../commun/Pagination';
import GenericTable from '../../commun/GenericTable';
import StatusTabs from '../../commun/StatusTabs';
import Chatbox from '../../commun/ChatBox';
import { entrepriseCandidatureStatus } from '../../commun/constants/options';
import Footer from '../../commun/Footer';

const CandidaturesEntreprise = () => {
  const [displayMode, setDisplayMode] = useState('table');

  const navigate = useNavigate();
  const entrepriseName = localStorage.getItem('entrepriseName');
  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [allCandidatures, setAllCandidatures] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});
  const [page, setPage] = useState(1);
  const [visibleCount, setVisibleCount] = useState(8);
  const itemsPerPage = 8;

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) navigate('/');
  }, [navigate]);

  useEffect(() => {
    const fetchCandidatures = async () => {
      const entrepriseId = localStorage.getItem('entrepriseId');
      if (!entrepriseId) return;

      try {
        const res = await fetch(`${API_BASE}/api/candidatures/entreprise/candidatures?entrepriseId=${entrepriseId}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        data.sort((a, b) => new Date(b.dateEnvoi) - new Date(a.dateEnvoi));
        setAllCandidatures(data);
      } catch (err) {
        console.error('Erreur de chargement des candidatures:', err);
      }
    };

    fetchCandidatures();
  }, [authToken]);

  useEffect(() => {
    const group = {};
    allCandidatures.forEach((c) => {
      const stat = c.statut || 'Inconnu';
      if (!group[stat]) group[stat] = [];
      group[stat].push(c);
    });
    setGrouped(group);
  }, [allCandidatures]);

  useEffect(() => {
    setPage(1);
    setVisibleCount(8);
  }, [filteredStatus, displayMode]);

  const displayedCandidatures = filteredStatus
    ? grouped[filteredStatus] || []
    : allCandidatures;

  const paginatedCandidatures = displayedCandidatures.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  const cardCandidatures = displayedCandidatures.slice(0, visibleCount);

  const columns = [
    { key: 'reference', label: 'Référence candidat' },
    { key: 'dateEnvoi', label: 'Date de candidature' },
    { key: 'mission', label: 'Mission' },
    { key: 'recruteur', label: 'Recruteur' },
    { key: 'statut', label: 'Statut' },
    { key: 'interlocuteur', label: 'Interlocuteur' },
  ];

  const renderActions = (row) => (
    <button
      className="btn-detail"
      onClick={() => navigate(`/Entreprise/DetailsCandidature/${row._id}`)}
    >
      Détails
    </button>
  );

const formatData = (list) => list.map((c) => {
  const rawStatus = c.statut || 'Inconnu';
  const matchedStatus = entrepriseCandidatureStatus.find((s) => s.value === rawStatus);

  // Affichage spécifique pour entreprise
  let displayStatus = matchedStatus?.label || rawStatus;
  if (rawStatus === "A traiter") {
    displayStatus = "Candidature à traiter";
  }
  return {
    reference: c.candidatId?.reference || 'N/A',
    mission: c.missionId?.nomMission || 'N/A',
    recruteur: c.recruteur && c.recruteur._id ? (
      <Link to={`/profil/${c.recruteur.utilisateur._id}`} className="recruteur-link">
        {c.recruteur.name}
      </Link>
    ) : 'N/A',    
    dateEnvoi: c.dateEnvoi
    ? new Date(c.dateEnvoi).toLocaleString('fr-FR', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    : 'N/A',  
    statut: (
      <span className="status-cell" style={matchedStatus?.style}>
        {displayStatus}
      </span>
    ),
    _id: c._id,
    interlocuteur: c.missionId?.createdBy
      ? `${c.missionId.createdBy.firstName} ${c.missionId.createdBy.lastName}`
      : 'Non défini',
  };
});


  const tableData = formatData(paginatedCandidatures);
  const cardData = formatData(cardCandidatures);

  return (
    <div className="entreprise-page">
      <HeaderEntreprise entrepriseName={entrepriseName} authToken={authToken} userId={userId} />
      <main className="pageContainer">
        <h2 className="pageTitle">Mes candidatures</h2>

        <StatusTabs
          statuses={grouped}
          activeStatus={filteredStatus}
          onStatusChange={setFilteredStatus}
          statusStylesSource={entrepriseCandidatureStatus}
        />

        <div className="tableWrapper">
          <GenericTable
            displayMode={displayMode}
            setDisplayMode={setDisplayMode}
            columns={columns}
            data={displayMode === 'card' ? cardData : tableData}
            renderActions={renderActions}
            totalItems={displayMode === 'card' ? cardData.length : displayedCandidatures.length}
            showCheckboxes={false}
          />

          {displayMode === 'table' && (
            <Pagination
              page={page}
              setPage={setPage}
              totalItems={displayedCandidatures.length}
              itemsPerPage={itemsPerPage}
            />
          )}

          {displayMode === 'card' && visibleCount < displayedCandidatures.length && (
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <button
                onClick={() => setVisibleCount((prev) => prev + 8)}
                className="btn-charger-plus"
              >
                Charger plus
              </button>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <Chatbox userRole="entreprise" />
    </div>
  );
};

export default CandidaturesEntreprise;
